export default "<body>\r\n <router-outlet></router-outlet>\r\n</body>\r\n"